export { default } from "./SvgIcon.mjs";
export { default as createSvgIcon } from "./createSvgIcon.mjs";
export { default as svgIconClasses } from "./svgIconClasses.mjs";
export * from "./svgIconClasses.mjs";